module.exports = __webpack_public_path__ + "img/enableAverageUnitPrice_01.6d49224c.png";